import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AuthService {


    static userLogin(item) {
        return axiosInstance.post(API_BASE_URL + API_PATHS.userlogin, item)
            .then((response) => {

                if (response?.data?.success === true) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("accessToken", response.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.refreshToken);
                    return response.data;
                } else {
                    // If the login attempt was unsuccessful, throw an error
                    throw new Error(response?.data?.message || 'Invalid credintials');
                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }



    static register(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.register}`;
        return axiosInstance
            .post(api, item)
    }



    static verifyotp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.verifyotp}`;
        return axiosInstance
            .post(api, item)
    }

    static forgotPassword(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.forgotpassword}`;
        return axiosInstance
            .post(api, item)
    }

    static setPassword(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.setpassword}`;
        return axiosInstance
            .post(api, item)
    }




    static getProfile() {

        const userData = JSON.parse(
            localStorage.getItem("user")
        );

        const role = userData?.role;

        // ADMIN PROFILE API
        const endpoint =
            role === "admin"
                ? "admin/getprofile"
                : API_PATHS.getProfile;

        return axiosInstance.get(
            API_BASE_URL + endpoint
        );
    }


    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) : "";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default AuthService;
